import React, { useState } from "react";
import { aplClient } from "../../aplApi/apiClient";
import { UserPermissions, userHasPermissionAnyLine } from "../../aplUtils/permissions";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";

export default function SqlDeploy() {
    const aplSettings = AplSettingsSelector();
    const [responseJson, setResponseJson] = useState("");
    const [version, setVersion] = useState({
        patch: 0,
        updatedAplVersion: "",
        installedDto: new Date("2000-01-01T00:00:00+00:00")
    } as {
        patch: number;
        updatedAplVersion: string;
        installedDto: Date;
    });
    const [cleanup, setCleanup] = useState([] as { objectName: string; dropStatement: string }[]);
    

    const onNextPatch = () => {
        try {
            setResponseJson("Working...");
            aplClient()
                .get(`setup/update/nextpatch`)
                .then(response => {
                    if (response.data) {
                        let jsonStr = JSON.stringify(response.data, null, 2);
                        setResponseJson(jsonStr);
                    } else {
                        setResponseJson("No data returned...");
                    }
                    getVersion();
                });
        } catch (ex) {
            setResponseJson("Failed!");
            getVersion();
        }
    };

    const onUpdateClickDropCreate = () => {
        try {
            setResponseJson("Working...");
            aplClient()
                .get(`setup/update/${aplSettings.siteId}/false`)
                .then(response => {
                    if (response.data) {
                        let jsonStr = JSON.stringify(response.data, null, 2);
                        setResponseJson(jsonStr);
                    } else {
                        setResponseJson("No data returned...");
                    }
                    getVersion();
                });
        } catch (ex) {
            setResponseJson("Failed!");
            getVersion();
        }
    };

    const onUpdateClickCreateOrAlter = () => {
        try {
            setResponseJson("Working...");
            aplClient()
                .get(`setup/update/${aplSettings.siteId}/true`)
                .then(response => {
                    if (response.data) {
                        let jsonStr = JSON.stringify(response.data, null, 2);
                        setResponseJson(jsonStr);
                    } else {
                        setResponseJson("No data returned...");
                    }
                    getVersion();
                });
        } catch (ex) {
            setResponseJson("Failed!");
            getVersion();
        }

    };

    const onBackupClick = async () => {
        try {
            setResponseJson("Working...");
            aplClient()
                .get("setup/backup")
                .then(response => {
                    if (response.data) {
                        let jsonStr = JSON.stringify(response.data, null, 2);
                        setResponseJson(jsonStr);
                    } else {
                        setResponseJson("No data returned...");
                    }
                });
        } catch (ex) {
            setResponseJson("Failed!");
        }
        getVersion();
    };

    const getListOfProcsToDrop = async () => {
        aplClient()
            .get("setup/cleanup")
            .then(x => {
                setCleanup(x.data);
            });
    };

    const getVersion = async () => {
        aplClient()
            .get("setup/version")
            .then(x => {
                setVersion(x.data);
            });
    };

    useState(() => {
        getListOfProcsToDrop();
        getVersion();
    });

    let hasAdmin = userHasPermissionAnyLine(aplSettings.permsSets, UserPermissions.Admin);

    if (!hasAdmin) {
        return <div>UserPermissions.Admin missing</div>;
    }

    return (
        <React.Fragment>
            <div className="container">
                <form id="form1" action="">
                    <div className="h6">Last Updated</div>
                    <div className="row">
                        <div className="col">
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    id="txtInstalledDto"
                                    className="form-control form-control-sm"
                                    value={`${version.installedDto}`}
                                    onChange={() => {}}
                                />
                                <input
                                    type="text"
                                    id="txtCurrentVersion"
                                    className="form-control form-control-sm"
                                    value={version.patch}
                                    onChange={() => {}}
                                />
                                <input
                                    type="text"
                                    id="txtUpdatedAplVersion"
                                    className="form-control form-control-sm"
                                    value={version.updatedAplVersion}
                                    onChange={() => {}}
                                />
                                <div className="input-group-append">
                                
                                    <button id="btnNextPatch" className="btn btn-sm btn-primary" type="button" onClick={onNextPatch}>
                                        NextPatch
                                    </button>
                                    <button id="btnUpdateDropCreate" className="btn btn-sm btn-primary" type="button" onClick={onUpdateClickDropCreate}>
                                        DropCreate
                                    </button>
                                    <button id="btnUpdateCreateOrAlter" className="btn btn-sm btn-primary" type="button" onClick={onUpdateClickCreateOrAlter}>
                                        CreateOrAlter
                                    </button>
                                    <button id="btnBackup" className="btn btn-sm btn-primary" type="button" onClick={onBackupClick}>
                                        Backup
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <br />

            <div className="container" id="txtErrorContainer">
                <div className="h6">ResponseJSON</div>
                <pre id="txtError">{responseJson}</pre>
            </div>

            <div className="container">
                <div className="h6">Integration replacement command (to be run as admin)</div>
                <pre id="txtBtSetup"></pre>
            </div>

            <br />

            <div className="container">
                <div className="h6">Procs to be dropped (make sure no replication sprocs listed)</div>
                <br />
                <table className="table table-striped table-sm" id="procsTable">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">ProcName</th>
                            <th scope="col">DropStatement</th>
                        </tr>
                    </thead>
                    <tbody id="procsTableTbody">
                        {cleanup.map((x, y) => (
                            <tr key={y}>
                                <td>{y}</td>
                                <td>{x.objectName}</td>
                                <td>{x.dropStatement}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
}